import { PATH_HOME } from "@hopper-b2b/hopper-utils";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ActionModal, ExpectantBunny } from "@hopper-b2b/ui";
import clsx from "clsx";
import { useContext } from "react";
import { UnauthorizedContext } from "../Unauthorization";
import "./styles.scss";

const ExpiredSession = () => {
  const { t } = useI18nContext();
  const authState = useContext(UnauthorizedContext);
  const showModal = authState === "UNAUTHORIZED";

  const onClick = () => {
    // History navigation is not enough to refresh the session, we need to do a hard navigation
    window.location.href = PATH_HOME;
  };

  return (
    <ActionModal
      className={`expired-session-modal hopper-invalid-session-modal`}
      open={showModal}
      onClose={onClick}
      onClick={onClick}
      buttonLabel={t("expiredSessionModal.confirm")}
      disabled={!showModal}
    >
      <div
        className={clsx("expired-session-modal-content action-modal-content")}
      >
        <img className="error-icon image" src={ExpectantBunny} alt="" />
        <div className={clsx("title")}>{t("expiredSessionModal.title")}</div>
        <div className={clsx("description")}>
          {t("expiredSessionModal.description")}
        </div>
      </div>
    </ActionModal>
  );
};

export default ExpiredSession;
